module.exports = __webpack_public_path__ + "static/img/coupons-10-check.2d1d1e95.png";